var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dropZoneRef",class:_setup.twMerge(
      [
        'relative overflow-hidden rounded-md',
        _setup.highlightDropZone
          ? _setup.isValidType
            ? 'outline-dashed outline-2 outline-offset-4 outline-primary-500'
            : 'outline-dashed outline-2 outline-offset-4 outline-red-500'
          : '',
      ],
      _vm.twClass,
    )},[_vm._t("default"),_vm._v(" "),(_setup.highlightDropZone && !_setup.isValidType)?_c('div',{staticClass:"absolute inset-0 z-10 flex items-center justify-center rounded-md bg-red-400/20 backdrop-blur-sm"},[_c('div',{staticClass:"rounded-lg py-4 text-center"},[_c('div',{staticClass:"mb-2 font-semibold text-red-600"},[_vm._v("\n        "+_vm._s(_vm.$t('unsupportedFileType'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"text-sm text-red-600"},[_vm._v("\n        "+_vm._s(_setup.props.unsupportedFileTypeHint ?? _vm.$t('uploadDocumentAcceptHint'))+"\n      ")])])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }